<div class="row">
    <div class="col col-lg-3 logo">
        <a *ngIf="!plt.is('cordova') && !themeConfig.disableLogoLink"
           class="link"
           href="https://skillsclub.com">
            <img src="/assets/images/theme/full-logo-light.svg"
                 alt="SkillsClub" />
        </a>

        <img *ngIf="!plt.is('cordova') && themeConfig.disableLogoLink"
             src="/assets/images/theme/full-logo-light.svg"
             alt="SkillsClub" />

        <a *ngIf="plt.is('cordova')"
           class="link"
           href="/">
            <img src="/assets/images/theme/full-logo-light.svg"
                 alt="SkillsClub" />
        </a>
    </div>
    <ng-container *ngIf="!plt.is('cordova')">
        <div class="col col-lg-5 menu">
            <ng-container *ngIf="!!themeConfig.headerLogo && !!themeConfig.headerLogoLink">
                <a class="theme-logo"
                   [href]="themeConfig.headerLogoLink"
                   target="_blank">
                    <img [src]="themeConfig.headerLogo"
                         height="52px"
                         alt="{{themeConfig.community}}" />
                </a>
            </ng-container>
            <ng-container *ngIf="!!themeConfig.headerLogo && !themeConfig.headerLogoLink">
                <img [src]="themeConfig.headerLogo"
                     alt="{{themeConfig.community}}" />
            </ng-container>
            <ng-container *ngIf="themeConfig.showHeaderMenu">
                <a [target]="!!themeConfig.name ? '_blank' : ''"
                   href="https://skillsclub.com/#benefits">{{'MENU_1'|trns}}</a>
                <a [target]="!!themeConfig.name ? '_blank' : ''"
                   href="https://skillsclub.com/#features">{{'MENU_2'|trns}}</a>
                <a [target]="!!themeConfig.name ? '_blank' : ''"
                   href="https://skillsclub.com/#about">{{'MENU_3'|trns}}</a>
                <a [target]="!!themeConfig.name ? '_blank' : ''"
                   href="https://skillsclub.com/#partners">{{'MENU_4'|trns}}</a>
            </ng-container>
        </div>
        <div class="col col-lg-4 register">
            <a *ngIf="showRegistrationLink"
               class="btn btn-primary"
               [href]="themeConfig.registrationLink"
               [target]="themeConfig.registrationLinkSamePage ? '':'_blank'">
                {{ 'LOGIN_REGISTER_LINK_TEXT' | translate }}
            </a>
        </div>
    </ng-container>
</div>